// extracted by mini-css-extract-plugin
module.exports = {"container":"stageSelector_container__ze-E_","input":"stageSelector_input__3Fj-D","stageLabel":"stageSelector_stageLabel__1fWnU"};